import React, { useEffect, useState } from "react";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { Lightbox } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { AccountAllowedStatusAction } from "../Action/AccountAllowedStatusAction";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { setActionMenuParams } from "../../../../../../../DLU/DLUHelper";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { SubaccountSideMenuMap } from "../../../../../CustomNavigation/Entities/SubaccountSideMenuMap";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { RetirementAge } from "../../../../Common/PaymentsIn/SIPP/RetirementAge";
import { PlannedRetirement } from "../../../../../../../../Wrap/Constants/Enums/PlannedRetirement";
import { ProductOverviewProductInformationAction } from "../Action/ProductOverviewProductInformationAction";
import { DateHelper } from "../../../../../../../../react-core/Helpers/DateHelper";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { BeneficiaryLightbox } from "./BeneficiaryLightbox";
import { ProductOverviewSippBeneficiariesAction } from "../Action/ProductOverviewSippBeneficiariesAction";
import { Table } from "../../../../../../../Shared/Table/Table";
import { Beneficiary } from "../../../../../../../../Wrap/Models/Domains/Beneficiary/Beneficiary";
import { isNotEmpty } from "../../../../../../../../react-core/Html/Validation/RawValueRules";
import { ExpressionOfWishDocumentAction } from "../Action/ExpressionOfWishDocumentAction";
import { DocumentsLibrary } from "../../../../../../../../Wrap/Models/Domains/Documents/DocumentsLibrary";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { accountStatusMap } from "../../../../ClientSearch/Resource/Content";
import { AriaTooltip } from "../../../../../../../Shared/Tooltip/AriaTooltip"
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../../Urls";
import { BeneficiaryType } from "../../../../../../../../Wrap/Constants/Enums/Domain/BeneficiaryType";
import { BeneficiaryTooltipMessage } from "../Constant/Content";

const SIPPIncormation = (props) => {
    const { pensionInfo, taxInfo, beneficiariesInfo, subAccount, customerid, onChange, onDataChange, setSelectedStatus, selectedStatus, setIsValid, name, isValid, setData, data } = props;
    const [isShowEditLightbox, setIsShowEditLightbox] = React.useState(false);
    const [showEditRetirementDateLightbox, setShowEditRetirementDateLightbox] = useState(false);
    const [showEditBeneficiariesLightbox, setShowEditBeneficiariesLightbox] = useState(false);
    const [allowedStatus, setAllowedStatus] = useState(null);
    const [plannedRetirementType, setPlannedRetirementType] = useState(PlannedRetirement.Age);
    const [plannedRetirementDate, setPlannedRetirementDate] = useState(pensionInfo?.RetirementDate);
    const [retirementAge, setRetirementAge] = useState(null);
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [beneficiaryList, setBeneficiaryList] = useState(beneficiariesInfo);
    const [showExpressionOfWishDocument, setShowExpressionOfWishDocument] = useState<boolean>(false);
    const [expressionOfWishDocument, setExpressionOfWishDocument] = useState<DocumentsLibrary | null>(null);
    const [expressionOfWishLatestUpdateDate, setExpressionOfWishUpdateDate] = useState(null);

    const defaultAnnuityPurchaseAge: number = 99;
    const isHardcodedTaxInfo = taxInfo?.PayrollReference?.substr(taxInfo?.PayrollReference.length-8, 8) === "11111111";
    const isDefaultTaxInfo = taxInfo?.PayrollReference == null && taxInfo?.PayeTaxCode == null && taxInfo?.PayeTaxBasis == null;

    const getPayeTaxBasis = (): string => {
        if (CommonHelper.isNullOrEmpty(taxInfo?.PayeTaxCode) || isHardcodedTaxInfo || isDefaultTaxInfo) {
            return "N/A";
        }
        
        const taxCode = taxInfo.PayeTaxCode.toUpperCase();
        const lastChar = taxCode.charAt(taxCode.length - 1);
        
        if (lastChar === 'L' || lastChar === 'M' || lastChar === 'N' || lastChar === 'T') {
            return "Cumulative";
        }
        
        return "Emergency";
    };

    useEffect(() => {
        ProductOverviewProductInformationAction.getDateOfBirth(customerid, (data) => {
            setDateOfBirth(data);
        });
        getBeneficiaryInfo();
        getExpressionOfWishDocumentOnFirstRender();
    }, []);

    function saveRetirementDate() {
        ProductOverviewProductInformationAction.saveRetirementDate(customerid, plannedRetirementDate, () => {
            pensionInfo.RetirementDate = plannedRetirementDate;
            const age = calculateRetirementAge();
            setRetirementAge(age);
            pensionInfo.AnnuityPurchaseAge = age;
            setShowEditRetirementDateLightbox(false);
        });
    }

    const getBeneficiaryInfo = function () {
        ProductOverviewSippBeneficiariesAction.get(subAccount.HierarchyId, (callBack) => {
            setBeneficiaryList(callBack);
        });
    }

    function calculateRetirementAge(): number {
        var date = JsonDateParser.toDate(pensionInfo?.RetirementDate);
        var birthday = JsonDateParser.toDate(dateOfBirth);

        if (date == null || birthday == null) {
            return null;
        }

        return date.getFullYear() - birthday.getFullYear();       
    }

    const getExpressionOfWishDocumentOnFirstRender = function () {
        ExpressionOfWishDocumentAction.get(subAccount.HierarchyId, (documents: DocumentsLibrary) => {
            if (!CommonHelper.isNullOrEmpty(documents.Documents)) {
                updateExpressionOfWishDocumentInfo(documents);
            }
        });
    }

    const getExpressionOfWishDocumentOnSubmitChanges = function () {
        ExpressionOfWishDocumentAction.get(subAccount.HierarchyId, (documents: DocumentsLibrary) => {
            if (CommonHelper.isNullOrEmpty(documents.Documents)) {
                getExpressionOfWishDocumentOnSubmitChanges();
            } else if (CommonHelper.isNullOrEmpty(expressionOfWishDocument)) {
                updateExpressionOfWishDocumentInfo(documents);
            } else if (expressionOfWishDocument.Documents.length < documents.Documents.length) {
                updateExpressionOfWishDocumentInfo(documents);
            } else {
                getExpressionOfWishDocumentOnSubmitChanges();
            }
        });
    }

    const updateExpressionOfWishDocumentInfo = function (documents: DocumentsLibrary) {
        setExpressionOfWishDocument(documents);
        expressionOfWishLatestDate(documents);
        setShowExpressionOfWishDocument(true);
    }

    const openDocument = () => {
        let documentsOrderedByDate = expressionOfWishDocument?.Documents.sort(function (a, b) {
            return -(+JsonDateParser.toDate(a.AddedOn) - +JsonDateParser.toDate(b.AddedOn));
        });

        let latestDocument = documentsOrderedByDate[0];
        window.open(`/popups/loaddocstore.aspx?filename=${latestDocument.FileNameEncryption}&encrypt=yes`, "_blank");
    }

    function expressionOfWishLatestDate(documents: DocumentsLibrary): void {
        let documentsOrderedByDate = documents?.Documents?.sort(function (a, b) {
            return -(+JsonDateParser.toDate(a.AddedOn) - +JsonDateParser.toDate(b.AddedOn));
        });
        if (documentsOrderedByDate) {
            setExpressionOfWishUpdateDate(documentsOrderedByDate[0].AddedOn);
        }
    }

    function getLatestUpdateDate(datetimes: Array<any>) {
        if (datetimes.length == 0) {
            return "N/A"
        }

        var latestUpdate = datetimes[0];
        datetimes.forEach((datetime) => {
            if (latestUpdate > datetime) {
                latestUpdate = datetime;
            }
        })
        return latestUpdate ? formatDate(latestUpdate) : "N/A";
    }

    function formatDate(datetime: any)  {
        const date = new Date(datetime);

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    return (
        <>
            <h2 className="mb-22">Product information</h2>
            <div className="row wide-gutter">                
                <div className="col-6 col-sm-fluid col-equalise">
                    <div className="d-flex f-direction-column">
                        <div className="row mb-10">
                            <div className="col-fluid col-middle">
                                <h3 className="mb-0">Pension information</h3>
                            </div>
                        </div>
                        <div className="panel-subtle pt-10 pb-10">
                            <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted">
                                <tbody>
                                    <tr>
                                        <th scope="row">Status</th>
                                        <td className="cell-right">{data?.Status}
                                            <Permission userClaim={[
                                                UserClaim.AdviserPortalCustomerFullyAccessReadWrite,
                                                UserClaim.AdviserPortalCustomerPartialAccessReadWrite
                                            ]}>
                                                <button
                                                    type="button"
                                                    className="edit-circle-icon-button ml-3 label-sr-only"
                                                    title="Edit"
                                                    onClick={() => {
                                                        AccountAllowedStatusAction.getAccountAllowedStatus(
                                                            props.subAccount.HierarchyId,
                                                            (result) => {
                                                                setAllowedStatus(result);
                                                                setIsShowEditLightbox(true);
                                                            }
                                                        );
                                                    }}
                                                >
                                                    <span className="icon" aria-hidden="true"></span>
                                                    <span className="text">Edit Product Status</span>
                                                </button>
                                            </Permission>
                                            {isShowEditLightbox && (
                                                <Lightbox
                                                    cssWrapper="is-default-lightbox"
                                                    show={isShowEditLightbox}
                                                    onClose={() => setIsShowEditLightbox(false)}
                                                    title="Edit Product Status"
                                                >

                                                    <SelectEditor
                                                        id="customerStatus"
                                                        label="Status"
                                                        options={allowedStatus}
                                                        getText={(v) => {
                                                            return accountStatusMap[v];
                                                        }}
                                                        placeholder={"Please select status"}
                                                        selected={selectedStatus}
                                                        onChange={(v) => setSelectedStatus(v)}
                                                    />
                                                    <button
                                                        className="btn secondary mr-10"
                                                        onClick={() => {
                                                            setSelectedStatus(null);
                                                            setIsShowEditLightbox(false);
                                                            setIsValid(true);
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        className="btn primary"
                                                        onClick={() => {
                                                            if (isValid) {
                                                                setIsValid(true);
                                                                const hierarchyid = props.headaccount.SubAccounts.find(
                                                                    (ele) => ele.HierarchyId == props.subAccount.HierarchyId
                                                                )?.HierarchyId;

                                                                ProductOverviewProductInformationAction.saveProductInformation(
                                                                    hierarchyid,
                                                                    name,
                                                                    selectedStatus,
                                                                    () => {
                                                                        setIsShowEditLightbox(false);
                                                                        setSelectedStatus(null);
                                                                        ProductOverviewProductInformationAction.getProductInformation(
                                                                            props.subAccount.HierarchyId,
                                                                            (data) => {
                                                                                setData(data);
                                                                            }
                                                                        );
                                                                    }
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        Apply
                                                    </button>
                                                </Lightbox>
                                            )}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Inception date</th>
                                        <td className="cell-right">{JsonDateParser.getFormatDate(
                                            JsonDateParser.toDate(subAccount?.InceptionDate),
                                            "dd/MM/yyyy")}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Anniversary date</th>
                                        <td className="cell-right">
                                            {JsonDateParser.toDate(pensionInfo?.AnniversaryDate) &&
                                                DateHelper.getDateStringAsddmmm(
                                                    JsonDateParser.toDate(pensionInfo?.AnniversaryDate)
                                                )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Retirement age/date</th>
                                        <td className="cell-right">
                                            {JsonDateParser.toDate(pensionInfo?.RetirementDate) != null && (
                                                <span className="mr-10">
                                                    {retirementAge || calculateRetirementAge()} &#40;
                                                    {JsonDateParser.getFormatDate(
                                                        JsonDateParser.toDate(pensionInfo?.RetirementDate),
                                                        "dd/MM/yyyy"
                                                    )}
                                                    &#41;
                                                </span>
                                            )}

                                            <Permission userClaim={[
                                                UserClaim.AdviserPortalCustomerFullyAccessReadWrite,
                                                UserClaim.AdviserPortalCustomerPartialAccessReadWrite
                                            ]}>
                                                <button
                                                    type="button"
                                                    className="edit-circle-icon-button label-sr-only"
                                                    title="Edit"
                                                    onClick={() => {
                                                        AccountAllowedStatusAction.getAccountAllowedStatus(
                                                            props.subAccount.HierarchyId,
                                                            (result) => {
                                                                setAllowedStatus(result);
                                                                setShowEditRetirementDateLightbox(true);
                                                            }
                                                        );
                                                    }}
                                                >
                                                    <span className="icon" aria-hidden="true"></span>
                                                    <span className="text">Edit Retirement Date</span>
                                                </button>
                                            </Permission>
                                            {showEditRetirementDateLightbox && (
                                                <Lightbox
                                                    cssWrapper="is-default-lightbox"
                                                    show={showEditRetirementDateLightbox}
                                                    onClose={() => setShowEditRetirementDateLightbox(false)}
                                                    title="Edit Retirement Age / Date"
                                                >
                                                    <RetirementAge
                                                        clientInfo={{ DateOfBirth: dateOfBirth }}
                                                        data={{
                                                            PlannedRetirement: plannedRetirementType,
                                                            PlannedRetirementDate: plannedRetirementDate,
                                                        }}
                                                        onChange={(d) => {
                                                            if (d.PlannedRetirement != null) {
                                                                setPlannedRetirementType(d.PlannedRetirement);
                                                            }
                                                            if (d.PlannedRetirementDate != null) {
                                                                setPlannedRetirementDate(d.PlannedRetirementDate);
                                                            }
                                                        }}
                                                        onRef={() => { }}
                                                    />

                                                    <div className="row mt-20">
                                                        <div className="col-auto">
                                                            <button
                                                                className="button mr-20"
                                                                onClick={() => setShowEditRetirementDateLightbox(false)}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                        <div className="col-auto">
                                                            <button
                                                                className="button"
                                                                onClick={() => saveRetirementDate()}
                                                            >
                                                                Save
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Lightbox>
                                            )}
                                        </td>
                                    </tr>

                                    {
                                        !CommonHelper.isNullOrEmpty(pensionInfo?.AnnuityPurchaseAge) &&
                                        pensionInfo?.AnnuityPurchaseAge !== defaultAnnuityPurchaseAge &&
                                        (<tr>
                                            <th scope="row">Annuity purchase age</th>
                                            <td className="cell-right">{pensionInfo?.AnnuityPurchaseAge} </td>
                                        </tr>)
                                    }



                                    <tr>
                                        <th scope="row">MPAA date triggered</th>
                                        <td className="cell-right">{pensionInfo?.MPAADateTriggered ?
                                            JsonDateParser.getFormatDate(
                                                JsonDateParser.toDate(pensionInfo.MPAADateTriggered),
                                                "dd/MM/yyyy"
                                            )
                                            :
                                            "N/A"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th scope="row">MPAA trigger reason</th>
                                        <td className="cell-right">{pensionInfo?.Reason == "Not Specified" ? "N/A" : pensionInfo?.Reason}</td>
                                    </tr>

                                    <tr>
                                        <th scope="row">Court order</th>
                                        <td className="cell-right">{pensionInfo?.HasCourtOrder ? "Yes" : "No"}</td>
                                    </tr>

                                    <tr>
                                        <th scope="row">Court order number</th>
                                        <td className="cell-right">
                                            {pensionInfo?.HasCourtOrder ? pensionInfo?.CourtOrderNumber : "N/A"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* <!-- Second Column for Manage Income --> */}

                <div className="col-6 col-sm-fluid col-equalise">
                    <div className="d-flex f-direction-column">
                        <div className="row mb-10">
                            <div className="col-fluid col-middle">
                                <h2 className="h3 mb-0">Manage investment income</h2>
                            </div>
                        </div>
                        <div className="panel-subtle pt-10 pb-25">
                            <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted mb-15">
                                <tbody>
                                    <tr>
                                        <th scope="row">Instruction for income funds</th>
                                        <td className="cell-right">{data?.IncomeOption}</td>
                                    </tr>
                                </tbody>
                            </table>
                            {checkPermission(UserClaim.AdviserPortalDluManageIncomeCanView) && (
                                <div>
                                    <a
                                        href={
                                            "/clients/cash/manageincome.aspx?claccountid=" +
                                            props.headaccount?.HeadClAccountId
                                        }
                                        className="hyperlink"
                                        onClick={() => {
                                            setActionMenuParams({
                                                headaccounthierarchyId: props.headaccount?.HierarchyId,
                                                subaccountHierarchyId: subAccount?.HierarchyId,
                                                levelHierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                    HierarchyLevelName.Customer,
                                                    customerid
                                                ),
                                                SideMenu: SubaccountSideMenuMap.getSubMenuBySubAccountType(
                                                    subAccount?.SubAccountType
                                                ),
                                            });
                                        }}
                                    >
                                        View or edit income
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex f-direction-column">
                        <div className="row mb-10">
                            <div className="col-fluid col-middle">
                                <h2 className="h3 mb-0">Tax information</h2>
                            </div>
                        </div>
                        <div className="panel-subtle pt-10 pb-10">
                            { (isHardcodedTaxInfo || !taxInfo || isDefaultTaxInfo) && <span>Sorry, tax code currently unavailable</span> }
                            <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted">
                                <tbody>
                                    <tr>
                                        <th scope="row">Payroll reference</th>
                                        <td className="cell-right">
                                            {CommonHelper.isNullOrEmpty(taxInfo?.PayrollReference) || isHardcodedTaxInfo || isDefaultTaxInfo
                                                ? "N/A"
                                                : taxInfo?.PayrollReference}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th scope="row">PAYE tax code</th>
                                        <td className="cell-right">
                                            {CommonHelper.isNullOrEmpty(taxInfo?.PayeTaxCode) || isHardcodedTaxInfo || isDefaultTaxInfo
                                                ? "N/A"
                                                : taxInfo?.PayeTaxCode}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">PAYE tax basis</th>
                                        <td className="cell-right">
                                            {getPayeTaxBasis()}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th scope="row">Effective date</th>
                                        <td className="cell-right">
                                            {CommonHelper.isNullOrEmpty(taxInfo?.StartDate) || isHardcodedTaxInfo || isDefaultTaxInfo
                                                ? "N/A"
                                                : JsonDateParser.getFormatDateString(
                                                    new Date(taxInfo?.StartDate),
                                                    "dd/MM/yyyy"
                                                )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <hr />
            <div className="row">
            <div className="col-6 col-sm-fluid">
                <div className="d-flex f-direction-column">
                    <div className="row mb-10">
                        <div className="col-fluid col-middle d-flex align-items-center">
                            <h2 className="h3 mb-0">Beneficiaries</h2>
                            <AriaTooltip cssWrapper="is-info-icon ml-8 tooltip-text" showCloseButton={true}>
                                {BeneficiaryTooltipMessage}
                            </AriaTooltip>
                        </div>
                        <div className="col-auto col-middle">
                            <Permission userClaim={UserClaim.AdviserPortalBeneficiariesReadWrite}>
                                <button
                                    type="button"
                                    className="edit-circle-icon-button label-sr-only"
                                    title="Edit"
                                    onClick={() => {
                                        AccountAllowedStatusAction.getAccountAllowedStatus(
                                            props.subAccount.HierarchyId,
                                            (result) => {
                                                setAllowedStatus(result);
                                                setShowEditBeneficiariesLightbox(true);
                                            }
                                        );
                                    }}
                                >
                                    <span className="icon" aria-hidden="true"></span>
                                    <span className="text">Edit Beneficiaries</span>
                                </button>
                            </Permission>
                            {showEditBeneficiariesLightbox && (
                                <BeneficiaryLightbox
                                    subAccount={subAccount}
                                    data={beneficiaryList}
                                    callBack={(v) => {
                                        setShowEditBeneficiariesLightbox(v);
                                        getBeneficiaryInfo();
                                    }}
                                    callBackOnSubmit={() => {
                                        setShowExpressionOfWishDocument(false);
                                        getExpressionOfWishDocumentOnSubmitChanges();
                                    }}
                                    showBox={showEditBeneficiariesLightbox}
                                    onChange={undefined}
                                    onRef={(ref) => { }}
                                ></BeneficiaryLightbox>
                            )}
                        </div>
                    </div>
                    <div className="panel-subtle pt-10 pb-10">
                        <Table
                            data={beneficiaryList}
                            col={[
                                {
                                    title: "Name",
                                    key: "Name",
                                    render: (data, row: Beneficiary, index) => {
                                        let given = isNotEmpty(row?.Name?.Given) ? row?.Name?.Given : "";
                                        let family = !(row.Type == BeneficiaryType.Individual) ? "" : isNotEmpty(row?.Name?.Family) ? row?.Name?.Family : "";
                                        return <>{given + " " + family}</>;
                                    },
                                    thCssWrapper: "cell-left",
                                    tdCssWrapper: "cell-left",
                                },
                                {
                                    title: "Proportion",
                                    key: "Proportion",
                                    render: (data, row: Beneficiary, index) => {
                                        return <>{data.toFixed(2)}%</>;
                                    },
                                    thCssWrapper: "cell-left",
                                    tdCssWrapper: "cell-left",
                                },
                            ]}
                            showEmptyMsg
                            emptyMsg="No beneficiaries are currently set up for the pension."
                            cssWrapper="mb-60"
                        />
                        { !CommonHelper.isNullOrEmpty(beneficiaryList) ?
                        <p>Last updated : {getLatestUpdateDate(beneficiaryList.filter(x => x.LastModified != null && x.LastModified != undefined).map(x => x.LastModified))}</p>
                        :
                        <p>Last updated : N/A</p>
                        }
                        <div className="mb-10">
                            Any completed Aberdeen SIPP Death Benefits Nomination form or other scheme member instructions can be viewed in the
                            <button
                                className="hyperlink ml-3"
                                onClick={() =>
                                    Navigator.navigateTo(
                                        Urls.get().main.PortfolioDashboard({
                                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                HierarchyLevelName.Customer,
                                                customerid
                                            ),
                                        })["documents"]
                                    )
                                }
                            >
                                Document library
                            </button>
                            <span>.</span>
                        </div>
                        {/* <div className="col-12 col-sm-fluid col-left ml-15 mb-20">
                            <button
                                className="hyperlink"
                                onClick={() =>
                                    Navigator.navigateTo(Urls.get().UpdateLifetimeAllowanceDetail, {
                                        scrollAfterNavigating: true,
                                        queryParamsObject: {
                                            hierarchyid: props.accountHierarchyId,
                                        },
                                    })
                                }
                            >
                                Update Allowance Details
                            </button>
                        </div> */}

                        {/* {showExpressionOfWishDocument ?
                            (
                                <div className="panel-subtle pt-10 pb-10">
                                    <button
                                        key={ArrangementTypeMap[1]}
                                        title="Expression of wish form"

                                        className={"hyperlink text-left"}
                                        onClick={openDocument.bind(this)}
                                    >{ArrangementTypeMap[1]}.
                                    </button>
                                    <p>Last Updated: {expressionOfWishLatestUpdateDate && JsonDateParser.getFormatDate(expressionOfWishLatestUpdateDate, "dd/MM/yyyy hh:mm")}</p>
                                </div>
                            )
                            :
                            (
                                CommonHelper.isNullOrEmpty(beneficiaryList)
                                    ?
                                    <></>
                                    :
                                    <div>
                                        <p>Loading document</p>
                                        <span className="lds-dual-ring label-sr-only ml-20"></span>
                                    </div>
                            )
                        } */}
                    </div>
                </div>
            </div>
            </div>
        </>
    );
};

export default SIPPIncormation;
